import { Dap as DapPackage } from '@move-frontend/dap';
import { FlightListService } from '../../flights/overview/domain/services/FlightListService';

// NOTE: This Dap implementation was created to support the old GOAA endpoint for the MCO 1.0 release
// When the new GOAA endpoint is ready this implementation should be removed

class Dap extends DapPackage {
	public flights() {
		return new FlightListService(this.client);
	}
}

export const dap = new Dap(
	process.env.MCO_API_KEY as string,
	process.env.DAP_BASE_URI as string,
);
